import { useNavigate } from 'react-router-dom';
import { ui, statusBadge } from '../ui';
import { colors } from '../theme';
import { STATUS_LABEL } from '../statusLabels';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** Список метчей текущей анкеты — переиспользуется в Applications.js (админ) и Clients.js
 * (куратор). Кто кого лайкнул/отклонил остаётся конфиденциальным, здесь только сам факт метча. */
export default function MatchesBlock({ userId, matches, profilePath }) {
  const navigate = useNavigate();

  return (
    <div style={ui.card}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>Метчи {matches.length > 0 ? `(${matches.length})` : ''}</div>
      {matches.length === 0 ? (
        <div style={ui.empty}>Метчей пока нет</div>
      ) : (
        matches.map(m => {
          const partner = m.user_a.id === userId ? m.user_b : m.user_a;
          const [bg, fg] = statusBadge[partner.status] || [colors.surface2, colors.textMuted];
          return (
            <div
              key={m.id}
              onClick={() => navigate(`${profilePath}?open=${partner.id}`)}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
                padding: '10px 0', borderBottom: `1px solid ${colors.border}`, cursor: 'pointer',
              }}
            >
              <span>{partner.first_name || '—'} ({partner.phone}) <span style={ui.badge(bg, fg)}>{STATUS_LABEL[partner.status] || partner.status}</span></span>
              <span style={{ color: colors.textMuted, fontSize: 12 }}>{fmt(m.matched_at)}</span>
            </div>
          );
        })
      )}
    </div>
  );
}
